<div [formGroup]="formGroup" class="select-container">
  <mat-form-field appearance="outline">
    <mat-select
      multiple
      placeholder="Select {{ placeHolderName }}"
      formControlName="{{ formControlName }}"
      panelClass="selectOption"
    >
      <mat-option *ngFor="let data of optionData" [value]="data">{{
        data
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <div
    *ngIf="submitted && formGroup.get(formControlName)?.errors"
    class="mt-1 invalid-feedback text-red-500 text-xs"
  >
    <div *ngIf="formGroup.get(formControlName)?.errors?.['required']">
      {{ placeHolderName }} is required!
    </div>
  </div>
</div>
